<template>
  <svg
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
  >
    <path
      d="M860,631.07V602a7,7,0,0,0,1.08-1.51c6.51-17.69,17.44-25.35,36.29-25.36,23.33,0,46.66,0,70,0a47.14,47.14,0,0,0,9.44-.66c17.33-3.68,29.32-19.83,27.66-37-1.77-18.24-15.86-31.92-33.4-32.44a35.55,35.55,0,0,0-36.25,30c-.19,1.22-.6,2.4-1.19,4.7-14.33-14.5-28.07-28.3-41.59-42.31-.81-.84-.52-3.77.31-5,21-31.63,50.58-46.55,88.21-42.14,36.87,4.32,61.83,25.21,74.73,60.14,2,5.37,3.17,11,4.72,16.56v27a14.54,14.54,0,0,0-1.09,2.59c-10,45.92-45.1,74.38-92,74.42Q913.47,631.05,860,631.07Z"
      transform="translate(-860 -440)"
      style="fill: #0ebcfe"
    />
    <path
      d="M1060,527c-1.55-5.53-2.73-11.19-4.72-16.56-12.9-34.93-37.86-55.82-74.73-60.14-37.63-4.41-67.22,10.51-88.21,42.14-.83,1.26-1.12,4.19-.31,5,13.52,14,27.26,27.81,41.59,42.31.59-2.3,1-3.48,1.19-4.7a35.55,35.55,0,0,1,36.25-30c17.54.52,31.63,14.2,33.4,32.44,1.66,17.16-10.33,33.31-27.66,37a47.14,47.14,0,0,1-9.44.66c-23.33.05-46.66,0-70,0-18.85,0-29.78,7.67-36.29,25.36A7,7,0,0,1,860,602V440h200Z"
      transform="translate(-860 -440)"
      style="fill: #fdfefe"
    />
    <path
      d="M860,631.07q53.46,0,106.93-.06c46.88,0,82-28.5,92-74.42A14.54,14.54,0,0,1,1060,554v86H860Z"
      transform="translate(-860 -440)"
      style="fill: #fdfefe"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'AdrollLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
